import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { DYNAMIC_PAGE_REDIRECT_PATHS } from '../constants/externalUrls'
import { questFulfillUrl } from '../util/quest.helpers'
import { SplashScreen } from '../components/shared/loading-screen'
import { selectAuthProfile } from '../store/selectors/common'
import { openExternalUrl } from '../util/app/app.helpers'

const PageRedirectContainer = () => {
  const params = useParams()

  const authProfile = useSelector(selectAuthProfile)

  useEffect(() => {
    const path = params?.path
    const id = params?.brand
    const authToken =
      authProfile?.cognitoUser?.signInUserSession?.accessToken?.jwtToken
    if (path === DYNAMIC_PAGE_REDIRECT_PATHS.QUEST && id && authToken) {
      openExternalUrl(questFulfillUrl(id, authToken), true)
    }
  }, [params, authProfile])

  return <SplashScreen />
}

export default PageRedirectContainer
